import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {Title} from "@angular/platform-browser";
import {ChangeRequestService} from "../../../services/change-request.service";

@Component({
    selector: 'admin-tech-check-log',
    templateUrl: './tech-check-log.component.html',
    styleUrls: ['./tech-check-log.component.scss'],
    standalone: false
})
export class TechCheckLogComponent implements OnInit {

  techCheckLogs: string[];

  changeRequestID: string;

  constructor(private router: Router,
              private titleService: Title,
              private activatedRoute: ActivatedRoute,
              private changeRequestService: ChangeRequestService) {
  }

  ngOnInit() {
    this.titleService.setTitle('View Technical Check Results');
    this.getInputData();
  }

  getInputData() {
    if (this.activatedRoute.snapshot || !this.activatedRoute.snapshot.paramMap) {
      this.changeRequestID = this.activatedRoute.snapshot.paramMap.get('changeRequestID');
      const techCheckTestId = this.activatedRoute.snapshot.paramMap.get('techCheckTestId');
      this.changeRequestService.getTechnicalCheckResponse(this.changeRequestID, techCheckTestId).subscribe(data => {
        this.techCheckLogs = data.statusCheck.logs;
      }, error => {
        console.log(error);
      });
    } else {
      this.router.navigateByUrl('/user/home');
    }
  }

}
